module.exports = __webpack_public_path__ + "img/52114132_L.e4afeff6.png";